import { useEffect, useState } from "react";
import usePublicPageSeo from "../../../hooks/global/usePublicPageSeo";
import { userService } from "../../../services";
import { APP_DOMAIN } from "../../../utls/constants";

interface Creator {
  username: string;
  name: string;
}

const CreatorsProfilesPage = () => {
  const [creators, setCreators] = useState<Creator[]>([]);

  const title = "Twizz – Monétisez & Partagez Votre Contenu Exclusif";
  const description =
    "Créez, partagez et monétisez votre contenu exclusif sur Twizz. Échangez en toute sécurité avec vos abonnés et générez des revenus facilement !";

  usePublicPageSeo({
    path: "/profiles",
    title,
    description,
  });

  useEffect(() => {
    const fetchCreators = async () => {
      try {
        const response = await userService.getCreatorsProfiles();
        setCreators(response || []);
      } catch (error) {
        console.error("Error fetching creators:", error);
      }
    };

    fetchCreators();
  }, []);

  return (
    <nav aria-label="Creator Profiles">
      <h1 style={{ color: "white" }}>All Creators</h1>
      <details>
        <summary style={{ listStyle: "none" }}></summary>
        <ul>
          {creators.map((creator) => (
            <li key={creator.username} style={{ listStyle: "none" }}>
              <a href={`https://www.${APP_DOMAIN}/p/${creator.username}`} title={creator.name}>
                leak de {creator.name || creator.username}
              </a>
            </li>
          ))}
        </ul>
      </details>
    </nav>
  );
};

export default CreatorsProfilesPage;
